import { 
    Grid, 
    makeStyles, 
    useTheme, 
    useMediaQuery,
    Collapse 
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'

const useStyles = makeStyles(() => ({
    girdItem: {
        cursor: 'pointer',
        transition: '0.5s',
        marginTop: '20px'
    },
    flag: {
        textAlign: 'center',
        '& > .fi': {
            borderRadius: '8px',
            boxShadow: '0px 0px 4px 0px rgba(0, 0, 0, 0.25) inset',
            width: '95px',
            height: '70px',
            lineHeight: 'unset',
        },
    },
    flagTitle: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft: '10px'
    },
    detail: {
        backgroundColor: '#eee',
        padding: '20px',
        borderRadius: '8px',
        marginTop: '10px',
        height: '240px'
    },
    content: {
        overflowY: 'scroll',
        height: '200px'
    },
    detailImgContainer: {
        width: '200px',
        marginLeft: '10px'
    },
    detailImg: {
        objectFit: 'contain', 
        width: '100%', 
        height: '100%'
    },
    collapse: {
        position: 'absolute !important', 
        left: '0 !important', 
        width: '100% !important'
    }
}))

const DeminimisList = ({ data, open, onExpand, onClose }) => {
    const classes = useStyles()
    const theme = useTheme()
    const isXs = useMediaQuery(theme.breakpoints.down('xs'))
    const isSm = useMediaQuery(theme.breakpoints.down(1280))

    return (
        <Grid container style={{ position: 'relative' }}>
            {Object.entries(data).map(([k, v]) => {
                let mb = '0px'

                if (open === k) {
                    if (isXs) {
                        mb = '250px'
                    } else {
                        mb = '260px'
                    }
                }

                return (
                    <Grid
                        item
                        key={k}
                        xs={12}
                        sm={6}
                        lg={4}
                        className={classes.girdItem}
                        style={{ marginBottom: mb }}
                        onClick={() => onExpand(k)}
                    >
                        <Grid container>
                            <Grid item md={6}>
                                <div className={classes.flag}>
                                    {v.flag}
                                </div>
                            </Grid>
                            <Grid item md={3}>
                                <div className={classes.flagTitle}>{v.title}</div>
                            </Grid>
                        </Grid>
                        <Collapse in={open === k} className={classes.collapse}>
                            <Grid container className={classes.detail}>
                                <CloseIcon style={{ position: 'absolute', right: '10px' }} onClick={onClose} />
                                <Grid item lg={9} className={classes.content}>
                                    {v.content}
                                </Grid>
                                <Grid item>
                                    {!isXs && !isSm && (
                                        <div className={classes.detailImgContainer}>
                                            <img src='/static/img/faq/de-minimis.png' alt='de-minimis' className={classes.detailImg} />
                                        </div>
                                    )}
                                </Grid>
                            </Grid>
                        </Collapse>
                    </Grid>
                )
            })}
        </Grid>
    )
}

export default DeminimisList